import { createContext, useContext } from 'react';

export const FiltersDataManager = createContext(null);

export const useFiltersDataManager = () => {
  const ctx = useContext(FiltersDataManager);

  if (!ctx) {
    throw new Error(
      'Filters Data Manager context is undefined, please verify you are calling useFiltersDataManager() as child of a <Filters /> or  <FiltersCollection /> component.'
    );
  }

  return ctx;
};

export default FiltersDataManager;
